// @ts-nocheck
import getReplayHighlightRanges from "src/features/highlighted-product/util/get-replay-highlight-ranges";

export default function replayHighightedProductFromCurrentTime(
  currentTime: number,
  replayHighlightedProduct: any
) {
  const highlightRanges = getReplayHighlightRanges(replayHighlightedProduct);

  const foundHighlights = Array.from(highlightRanges.values()).filter(
    (range) => range.start < currentTime && range.end > currentTime
  );

  return foundHighlights?.length > 0 ? foundHighlights[0].highlight : {};
}
